"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.app = void 0;
/**
 * Brand/Live Application Interface
 */
class App {
    /**
     * Initialize the Brand/Live app.
     */
    init(options) {
        if (!this._firebase) {
            this._firebase = options.firebase;
            if (options.useEmulators === true) {
                this.setupEmulators();
            }
        }
    }
    /**
     * Returns the firebase client library.  This will throw an exception if
     * the app hasn't been initialized.
     */
    get firebase() {
        if (!this._firebase) {
            throw new Error('Firebase has not been set...have you called initializeApp?');
        }
        return this._firebase;
    }
    setupEmulators() {
        /**
         * FIREBASE_FIRESTORE_EMULATOR_ADDRESS: 'localhost:9080'
         * FIREBASE_AUTH_EMULATOR_HOST: 'localhost:9099'
         */
        // Firestore
        if (process.env.FIRESTORE_EMULATOR_HOST) {
            const [host, port] = process.env.FIRESTORE_EMULATOR_HOST.split(':');
            this.firebase.firestore().useEmulator(host, parseInt(port));
        }
        // Auth
        if (process.env.FIREBASE_AUTH_EMULATOR_HOST) {
            this.firebase
                .auth()
                .useEmulator(`http://${process.env.FIREBASE_AUTH_EMULATOR_HOST}`);
        }
        // TODO: Get this programatically somehow...
        this.firebase.functions().useEmulator('localhost', 5001);
    }
}
exports.app = new App();
//# sourceMappingURL=app.js.map